import { render, staticRenderFns } from "./materialInputPriceView.vue?vue&type=template&id=d4e2a1f8&"
import script from "./materialInputPriceView.vue?vue&type=script&lang=js&"
export * from "./materialInputPriceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports